<template>
	<div class="spin-tracker circular-element">
		<div class="spins">{{ spins }}</div>
		<div class="title">Spins</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: 'SpinTracker',
	props: {
		addedSpins: {
			type: Number,
			required: false,
		},
	},
	computed: {
		...mapState({
			spinsRemaining: (state) => state.game.rounds.active.spinsRemaining,
		}),
		spins() {
			return this.addedSpins ? `+${this.addedSpins}` : this.spinsRemaining;
		},
	},
};
</script>

<style lang="scss" scoped>
	.spin-tracker {
		color: $gray-light;
		border-radius: 50%;
		box-sizing: initial;
		z-index: $z-top-mid;

		&.circular-element:after {
			background: radial-gradient(circle at center, #5B2518 0, $alt-color-dark 60%);
		}

		&:before {
			content: '';
			position: absolute;
			background: linear-gradient(0.25turn, $alt-color-extra-light, $alt-color);
			border-radius: 50%;
			width: 100%;
			height: 100%;
			box-sizing: unset;
			z-index: -1;
		}
	}

	.spins {
		font-family: $heading-font;
		font-size: $heading-size-lg;
		line-height: 1;
		background: linear-gradient(to right, $alt-color, $alt-color-extra-light, $alt-color-light);
		background-clip: text;
		-webkit-text-fill-color: transparent;

		@include desktop { font-size: $heading-size-xl; }
		@include desktop-sm { font-size: $heading-size-lg; }
	}

	.title {
		line-height: 1;
		color: $text-alt;
	}
</style>
